import { render, staticRenderFns } from "./LegalDocumentContent_Gqwc5X.vue?vue&type=template&id=57028eba&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_Gqwc5X.vue?vue&type=style&index=0&id=57028eba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57028eba",
  null
  
)

export default component.exports